import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';
import { Country } from './country.interface';

export class CountryService {
   async getCountries(query?: LocationQuery): Promise<Array<Country>> {
      return http.get('/countries', { ...cacheFirstConfig, params: { ...query } }).then((response: any) => response.data.data);
   }
}
